@if (item) {
  <div class="full-image-main">
    <div class="full-image-container">
      <div class="full-image-box">
        @if (!contentEdit) {
          <h4>{{ item.content.headline }}</h4>
        }
        @if (contentEdit) {
          <coin-v2-text-input
            [label]="'cms.content-pages.headline-text' | translate"
            [placeholder]="'cms.content-pages.headline-text' | translate"
            [(ngModel)]="item.content.headline" />
        }
        <div class="full-image-enlarge">
          @if (enableEnlarge) {
            <div
              class="enlarge-icon"
              (click)="enlargeImage()">
              <span class="material-icons">fit_screen</span>
            </div>
          }
          <div>
            <img
              aria-label="image"
              [src]="item.content.imageUrl" />
          </div>
        </div>
        @if (contentEdit) {
          <coin-v2-button
            class="full-image-change-picture"
            type="secondary"
            svgIcon="edit"
            text="Change Picture"
            (click)="editPicture(item.content)"></coin-v2-button>
        }
        @if (!contentEdit) {
          <p class="light">{{ item.content.text }}</p>
        }
        @if (contentEdit) {
          <coin-v2-text-input
            [label]="'cms.content-pages.text' | translate"
            [placeholder]="'cms.content-pages.text' | translate"
            [(ngModel)]="item.content.text" />
        }
      </div>
    </div>
  </div>
}
